module.exports = require("base64-arraybuffer");